import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47d40766"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-ui-dialog-title",
  style: {"top":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ExportDropdown = _resolveComponent("ExportDropdown")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_SwitchTerminalGroup = _resolveComponent("SwitchTerminalGroup")!
  const _component_MessagePush = _resolveComponent("MessagePush")!
  const _component_Approval = _resolveComponent("Approval")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_GroupPolicyDrawer = _resolveComponent("GroupPolicyDrawer")!
  const _component_RawDataDrawer = _resolveComponent("RawDataDrawer")!
  const _directive_date_format = _resolveDirective("date-format")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentAdaptLayout, { class: "cm-ui-shadow-container cm-ui-pt16 cm-ui-pl16 cm-ui-pr16 cm-ui-pb16 cm-ui-pb0" }, {
      header: _withCtx(() => [
        _createVNode(_component_SearchFilterBar, {
          style: {"padding":"0","background-color":"transparent"},
          modelValue: _ctx.queryParams,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.queryParams) = $event)),
          "form-columns": _ctx.filterFormColumns,
          "show-search": false,
          "popover-threshold": 2,
          onQuery: _ctx.handleQuery,
          onReset: _ctx.handleReset
        }, {
          first_model_id: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "cm-ui-mr10",
              size: "small",
              modelValue: _ctx.queryParams.first_model_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryParams.first_model_id) = $event)),
              modelModifiers: { number: true },
              clearable: "",
              filterable: "",
              onChange: _ctx.handleFirstModelChange,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelData.models, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.model_id,
                    label: _ctx.$t(item.labelKey),
                    value: item.model_id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          second_model_id: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "cm-ui-mr10",
              size: "small",
              modelValue: _ctx.queryParams.second_model_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryParams.second_model_id) = $event)),
              clearable: "",
              filterable: "",
              onChange: _ctx.handleQueryChange,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelData.secondModelSelectionOptions, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: _ctx.$t(item.labelKey),
                    value: item.model_id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_ExportDropdown, {
              "button-text-i18n-key": "noticeManage.exportRecord",
              onExport: _ctx.download
            }, null, 8, ["onExport"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "onQuery", "onReset"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_LoadMoreButton, {
          loading: _ctx.loading,
          current: _ctx.data.list.length,
          total: _ctx.data.total,
          onLoadMore: _ctx.loadMoreData
        }, null, 8, ["loading", "current", "total", "onLoadMore"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          width: "100%",
          height: "100%",
          data: _ctx.data.list
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "record_time",
              label: _ctx.$t('noticeManage.time')
            }, {
              default: _withCtx((scope) => [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_date_format, {value: scope.row.record_time * 1000, format: 'YYYY-MM-DD HH:mm'}]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "admin_name",
              label: _ctx.$t('noticeManage.adminName')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "first_model",
              label: _ctx.$t('noticeManage.firstModule')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.tModuleLabel(_ctx.modelData.firstModelIdMap, scope.row.first_model)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "second_model",
              label: _ctx.$t('noticeManage.secondModule')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.tModuleLabel(_ctx.modelData.secondModelIdMap, scope.row.second_model)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "operation",
              label: _ctx.$t('noticeManage.operationAction')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatAdminOperation(scope.row)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('noticeManage.operation')
            }, {
              default: _withCtx((scope) => [
                (!_ctx.isAdminLogDetailDisabled(scope.row))
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      class: "detail-link cm-ui-mr10",
                      type: "primary",
                      size: "small",
                      "data-id": scope.row.record_id,
                      "data-first": scope.row.first_model,
                      "data-second": scope.row.second_model,
                      "data-opt": scope.row.opt_data,
                      onClick: _withModifiers(_ctx.handlerViewDetail, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.detail')), 1)
                      ]),
                      _: 2
                    }, 1032, ["data-id", "data-first", "data-second", "data-opt", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_link, {
                  class: "detail-link",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (_ctx.showRawData(scope.row)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.rawData')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "data"])), [
          [_directive_loading, _ctx.loading],
          [_directive_load_more, _ctx.loadMoreData]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.dialogDetailVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogDetailVisible) = $event)),
      "destroy-on-close": "",
      size: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ContentAdaptLayout, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('noticeManage.adminOperationLogDetailTitle', { first: _ctx.tModuleLabel(_ctx.modelData.firstModelIdMap, _ctx.dialogDetailOptions.first_model_id), second: _ctx.tModuleLabel(_ctx.modelData.secondModelIdMap, _ctx.dialogDetailOptions.second_model_id) })), 1),
            (_ctx.dialogDetailOptions.second_model_id === _ctx.SWITCH_TERMINAL_SECOND_MODEL_ID)
              ? (_openBlock(), _createBlock(_component_SwitchTerminalGroup, {
                  key: 0,
                  id: _ctx.dialogDetailOptions.record_id,
                  data: _ctx.dialogDetailOptions.opt_data
                }, null, 8, ["id", "data"]))
              : _createCommentVNode("", true),
            (_ctx.dialogDetailOptions.first_model_id === _ctx.MESSAGE_FIRST_MODEL_ID || [10, 11, 57, 59, 62, 61, 63, 64, 65,66,67].includes(_ctx.dialogDetailOptions.second_model_id))
              ? (_openBlock(), _createBlock(_component_MessagePush, {
                  key: 1,
                  id: _ctx.dialogDetailOptions.opt_data.task_id,
                  message: _ctx.dialogDetailOptions.opt_data.message
                }, null, 8, ["id", "message"]))
              : _createCommentVNode("", true),
            (_ctx.dialogDetailOptions.second_model_id === 50)
              ? (_openBlock(), _createBlock(_component_Approval, {
                  key: 2,
                  id: _ctx.dialogDetailOptions.opt_data.record_id
                }, null, 8, ["id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GroupPolicyDrawer, {
      modelValue: _ctx.groupPolicyDrawerData.visible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.groupPolicyDrawerData.visible) = $event)),
      "policy-id": _ctx.groupPolicyDrawerData.policyId,
      "operate-type": "read"
    }, null, 8, ["modelValue", "policy-id"]),
    _createVNode(_component_RawDataDrawer, {
      modelValue: _ctx.isShowRawData,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isShowRawData) = $event)),
      "raw-data": _ctx.currentRow
    }, null, 8, ["modelValue", "raw-data"])
  ], 64))
}